module.exports = __webpack_public_path__ + "static/media/yesAnimation.b8664eec.png";